/**
 * @generated SignedSource<<dba3d87d4aa5c34dce046089a92e5b56>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type timezone_useTimezoneDetectorUser$data = {
  readonly timezoneName: string | null | undefined;
  readonly timezoneOffset: number | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"user_useIsGuest" | "user_useIsMasked">;
  readonly " $fragmentType": "timezone_useTimezoneDetectorUser";
};
export type timezone_useTimezoneDetectorUser$key = {
  readonly " $data"?: timezone_useTimezoneDetectorUser$data;
  readonly " $fragmentSpreads": FragmentRefs<"timezone_useTimezoneDetectorUser">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "timezone_useTimezoneDetectorUser",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "timezoneName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "timezoneOffset",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "user_useIsGuest"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "user_useIsMasked"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "dfa66781bdcdf655aaab7725b8ab79cc";

export default node;
